/**
 * Created by piotr.pozniak@thebeaverhead.com on 15/06/2026.
 */
import { useCurrentOrganizationStore } from "../../../../../hooks/redux/currentOrganization";

export function useDNSProblemAlert() {
  const { currentOrganization } = useCurrentOrganizationStore();
  const dnsSettings = currentOrganization.model?.domain_dns;

  if (!dnsSettings?.validationCNameError && !dnsSettings?.routingCNameError) {
    return null;
  }

  return {
    id: "dnsProblem",
    variant: "warning",
    icon: "AlertTriangle",
    title: "Custom domain issue",
    body: "Your custom domain setup needs attention to keep working.",
    action: { label: "Review settings", to: "/custom-domain" },
  };
}

export default useDNSProblemAlert;
